import React, { useMemo } from "react";
import styles from "./Product.module.css";
import EditIcon from "Utils/Assets/SVGs/EditIcon";
import TrashIcon from "Utils/Assets/SVGs/TrashIcon";
import useImageUploadRules from "../../../Logic/Functions/Hooks/useImageUploadRules";
import { IManageProductCardProps } from "@model/Products.model";

const ManageProductCard: React.FC<IManageProductCardProps> = ({
  id,
  name,
  description,
  slug,
  imageUrl,
  images,
  onEdit,
  onDelete,
}) => {
  const { buildImageSrc } = useImageUploadRules({
    maxFiles: 1,
    maxSizeMB: 5,
    requireAtLeastOne: false,
    enforceTotalSize: false,
  });

  const thumbnailSrc = useMemo(() => {
    const thumbnailRaw =
      Array.isArray(images) && images.length
        ? typeof images[0] === "string"
          ? images[0]
          : images[0]?.url
        : imageUrl;

    return buildImageSrc(thumbnailRaw ?? null) ?? "";
  }, [images, imageUrl, buildImageSrc]);

  return (
    <div className={styles["mgc-card"]} data-testid="mgc-card">
      <div className={styles["mgc-thumbWrap"]} data-testid="mgc-thumb-wrap">
        {thumbnailSrc ? (
          <img
            src={thumbnailSrc}
            alt={name}
            className={styles["mgc-thumb"]}
            data-testid="mgc-image"
          />
        ) : (
          <div
            className={styles["mgc-thumbPlaceholder"]}
            data-testid="mgc-placeholder"
          />
        )}
      </div>

      <div className={styles["mgc-body"]} data-testid="mgc-body">
        <h3 className={styles["mgc-title"]} data-testid="mgc-title">
          {name}
        </h3>

        <p className={styles["mgc-desc"]} data-testid="mgc-description">
          {description || "—"}
        </p>

        <div className={styles["mgc-actions"]} data-testid="mgc-actions">
          <button
            className={styles["mgc-editBtn"]}
            data-testid="mgc-edit-button"
            onClick={() => onEdit(slug)}
          >
            <EditIcon className={styles["mgc-icon"]} />
            Edit
          </button>

          <button
            className={styles["mgc-deleteBtn"]}
            data-testid="mgc-delete-button"
            onClick={() => onDelete(id)}
          >
            <TrashIcon className={styles["mgc-icon"]} />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageProductCard;
